import { forwardRef, PropsWithChildren } from 'react';

import classNames from 'classnames';

import { ChevronLeftIcon } from '@anyx/shared-icons';


export interface MobilePreviewProps {
  withShadow?: boolean;
  containerClass?: string;
  mobilePreviewClass?: string;
  headerTitle?: string;
  backgroundClass?: string;
}

const PreviewHeader = ({ storeName }: { storeName: string }) => (
  <div className="bg-gray-5 relative h-16 rounded-t-xl pt-6">
    <div className="flex w-full items-center justify-center">
      <ChevronLeftIcon className="absolute left-6 h-6 w-6 text-white" />
      <p className="text-center font-semibold text-white">{storeName}</p>
    </div>
  </div>
);

export const MobilePreview = forwardRef<HTMLDivElement, PropsWithChildren<MobilePreviewProps>>(
  (
    {
      children,
      withShadow = true,
      containerClass,
      mobilePreviewClass,
      headerTitle,
      backgroundClass,
    },
    ref
  ) => {
    return (
      <div className="bg-gray-0 flex grow flex-col rounded-r">
        {withShadow && (
          <div
            className="absolute h-full w-[18px] opacity-10"
            style={{
              background:
                'linear-gradient(269.99deg, #000000 -113.6%, rgba(196, 196, 196, 0) 100%)',
              transform: 'matrix(-1, 0, 0, 1, 0, 0)',
            }}
          />
        )}
        <div
          className={classNames(
            'relative flex grow items-stretch justify-center px-14 py-10',
            containerClass
          )}
        >
          <div className={classNames('mobile-preview', mobilePreviewClass)}>
            <div className="absolute top-0 left-1/2 z-10 h-7 w-[186px] translate-x-[-50%] rounded-b-[12px] bg-white" />
            <div className="flex h-full flex-col overflow-hidden rounded-xl">
              {headerTitle && <PreviewHeader storeName={headerTitle} />}

              <div ref={ref} className={classNames('mobile-preview__background', backgroundClass)}>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);
